import { NavBar } from "@ipsos/navbar";
import { AppBar } from "../AppBar/AppBar.tsx";
import { ConnectedLabsModal } from "../LabsModal/ConnectedLabsModal.tsx";
import { ConnectedThemeToggle } from "../ThemeToggleButton/ConnectedThemeToggle.tsx";
import { useEffect } from "react";
import { getDocumentTitle } from "../../config/getDocumentTitle.ts";

const UnauthenticatedActions = () => (
  <>
    <ConnectedLabsModal />
    <ConnectedThemeToggle />
  </>
);

export const Header = (props: {
  enableGlobalNav: boolean;
  isAuthenticated: boolean;
  onLogoutClick?: () => Promise<void>;
  env: "dev" | "beta" | "prod";
  appTitle: string;
}) => {
  useEffect(() => {
    document.title = getDocumentTitle(props.appTitle);
  }, [props.appTitle]);
  return (
    <>
      {props.enableGlobalNav ? (
        <NavBar
          isAuthenticated={props.isAuthenticated}
          onLogoutClick={props.onLogoutClick}
          env={props.env}
          unauthenticatedActions={<UnauthenticatedActions />}
          appTitle={props.appTitle}
        />
      ) : (
        <AppBar
          isAuthenticated={props.isAuthenticated}
          onLogoutClick={props.onLogoutClick}
          unauthenticatedActions={<UnauthenticatedActions />}
          appTitle={props.appTitle}
        />
      )}
    </>
  );
};
